import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ContactGet } from '../../services';

export const fetchContactGet = createAsyncThunk(
    'contactGet/fetchContactGet',
    async () => {
        const response = await ContactGet()
        return response.result
    }
);

const contactGetSlice = createSlice({
    name: 'contactGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContactGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContactGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchContactGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default contactGetSlice.reducer;
